
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IDeptTreeItem, IDeptTreeItemParams } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 用户中心 - 部门列表
 */
export async function queryDeptTreeList() {
  let data = [] as IDeptTreeItem[];

  try {
    const { code, context, message } = await Http.post<Array<IDeptTreeItem>>(`${hostUrl}/iam/dept/tree-list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 上级部门列表
 */
export async function queryDeptParentList() {
  let data = [] as IDeptTreeItem[];

  try {
    const { code, context, message } = await Http.post<Array<IDeptTreeItem>>(`${hostUrl}/iam/dept/parent-list`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 查询部门下人员
 */
export async function queryDeptIdentityList(id: number) {
  let data = [] as any[];

  try {
    const { code, context, message } = await Http.post<any[]>(`${hostUrl}/iam/dept/identity-list`, { id });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 新增/编辑部门
 */
export async function deptTreeListManage(params: IDeptTreeItemParams, isAdd: boolean) {
  let data = [] as IDeptTreeItem[];

  try {
    const { code, context, message } = await Http.post<Array<IDeptTreeItem>>(`${hostUrl}/iam/dept/${isAdd ? 'add' : 'edit'}`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 删除部门
 */
export async function deptTreeListDelete(id: number, transferId: number) {

  try {
    const { code, message } = await Http.post<Array<IDeptTreeItem>>(`${hostUrl}/iam/dept/delete`, {
      id,
      transferId, 
    });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

}
